<template>
  <section>
    <div class="div_geral">
      <div class="container">
        <div class="div_form">
          <div class="div_img">
            <a class="voltar" href="/login">
              <span
                ><i class="bi bi-arrow-left"></i> Voltar para o Login</span
              ></a
            >
            <img src="/images/demode.webp" alt="Logo" />
            <p>Preencha as informações a seguir para criar a sua conta</p>
          </div>
          <div class="row">
            <div class="col-md-10 offset-md-1">
              <form @submit.prevent="criar()">
                <div class="row">
                  <h4>DA EMPRESA</h4>
                  <div class="col-md-6">
                    <label>CNPJ*</label>
                    <input
                      type="text"
                      class="input"
                      v-model="state.cliente.cnpj.value"
                      v-mask-cnpj
                      @blur="getInReceita(state.cliente.cnpj.value)"
                    />
                    <span class="text-danger" v-if="state.cliente.cnpj.error"
                      >Esse campo é obrigatório</span
                    >
                  </div>
                  <div class="col-md-6">
                    <label>Email*</label>
                    <input
                      type="email"
                      class="input"
                      v-model="state.cliente.email.value"
                    />
                    <span class="text-danger" v-if="state.cliente.email.error"
                      >Esse campo é obrigatório</span
                    >
                  </div>
                  <div class="col-md-7">
                    <label>Razão Social*</label>
                    <input
                      type="text"
                      class="input"
                      v-model="state.cliente.razao_social.value"
                    />
                    <span
                      class="text-danger"
                      v-if="state.cliente.razao_social.error"
                      >Esse campo é obrigatório</span
                    >
                  </div>
                  <div class="col-md-5">
                    <label>Nome Fantasia*</label>
                    <input
                      type="text"
                      class="input"
                      v-model="state.cliente.nome_fantasia.value"
                    />
                    <span
                      class="text-danger"
                      v-if="state.cliente.nome_fantasia.error"
                      >Esse campo é obrigatório</span
                    >
                  </div>
                  <div class="col-md-6">
                    <label>Telefone*</label>
                    <input
                      type="text"
                      class="input"
                      v-model="state.cliente.telefone.value"
                      v-mask-phone.br
                    />
                    <span
                      class="text-danger"
                      v-if="state.cliente.telefone.error"
                      >Esse campo é obrigatório</span
                    >
                  </div>
                  <div class="col-md-6">
                    <label>Atvidade*</label>
                    <select
                      class="select"
                      v-model="state.cliente.atvidade.value"
                    >
                      <option value="">Selecione</option>
                    </select>
                    <span
                      class="text-danger"
                      v-if="state.cliente.atvidade.error"
                      >Esse campo é obrigatório</span
                    >
                  </div>
                  <div class="col-md-6">
                    <label>Endereço*</label>
                    <input
                      type="text"
                      class="input"
                      v-model="state.cliente.endereco.value"
                    />
                    <span
                      class="text-danger"
                      v-if="state.cliente.endereco.error"
                      >Esse campo é obrigatório</span
                    >
                  </div>
                  <div class="col-md-2">
                    <label>Número*</label>
                    <input
                      type="text"
                      class="input"
                      v-model="state.cliente.numero.value"
                    />
                    <span class="text-danger" v-if="state.cliente.numero.error"
                      >Esse campo é obrigatório</span
                    >
                  </div>
                  <div class="col-md-4">
                    <label>Bairro*</label>
                    <input
                      type="text"
                      class="input"
                      v-model="state.cliente.bairro.value"
                    />
                    <span class="text-danger" v-if="state.cliente.bairro.error"
                      >Esse campo é obrigatório</span
                    >
                  </div>
                </div>
                <div class="row">
                  <label><strong>CONTATO COMERCIAL</strong></label>
                  <div class="col-md-6">
                    <label>Nome*</label>
                    <input
                      type="text"
                      class="input"
                      v-model="state.cliente.contato_nome.value"
                    />
                    <span
                      class="text-danger"
                      v-if="state.cliente.contato_nome.error"
                      >Esse campo é obrigatório</span
                    >
                  </div>
                  <div class="col-md-6">
                    <label>Telefone*</label>
                    <input
                      type="text"
                      class="input"
                      v-model="state.cliente.contato_telefone.value"
                      v-mask-phone.br
                    />
                    <span
                      class="text-danger"
                      v-if="state.cliente.contato_telefone.error"
                      >Esse campo é obrigatório</span
                    >
                  </div>
                </div>
                <div class="row">
                  <label><strong>DADOS DE ACESSO</strong></label>
                  <div class="col-md-6">
                    <label>Email*</label>
                    <input
                      type="email"
                      class="input"
                      v-model="state.cliente.login.value"
                    />
                    <span class="text-danger" v-if="state.cliente.login.error"
                      >Esse campo é obrigatório</span
                    >
                  </div>
                  <div class="col-md-6">
                    <label>Senha*</label>
                    <input
                      type="password"
                      class="input"
                      v-model="state.cliente.password.value"
                    />
                    <span
                      class="text-danger"
                      v-if="state.cliente.password.error"
                      >Esse campo é obrigatório</span
                    >
                  </div>
                </div>
                <div>
                  <div>
                    <input
                      type="checkbox"
                      id="concorda"
                      name="concorda"
                      v-model="state.concorda"
                    />
                    <label for="concorda"
                      >Ao criar sua cliente você concorda com os
                      <a href="/termos-de-uso" target="_blank"
                        ><span style="color: #560382">Termos de Uso</span>
                      </a>
                      e
                      <a style="color: #560382">Política de Privacidade</a>
                      da plataforma.
                    </label>
                  </div>
                  <button
                    type="submit"
                    id="submitButton"
                    class="btn_save"
                    :disabled="!state.concorda"
                    :class="[state.concorda ? 'btn_ativado' : 'btn_desativado']"
                  >
                    Cadastrar
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="toast" class="toast">Erro ao fazer login</div>
    <div id="toast_sucess" class="toast_sucess">
      Cliente cadastrado com sucesso
    </div>
  </section>
</template>

<script>
import { reactive } from "vue";
import services from "../../services";
import { useRouter } from "vue-router";

export default {
  setup() {
    const router = useRouter();

    const state = reactive({
      concorda: false,
      cliente: {
        cnpj: {
          value: "",
          error: false,
        },
        email: {
          value: "",
          error: false,
        },
        razao_social: {
          value: "",
          error: false,
        },
        nome_fantasia: {
          value: "",
          error: false,
        },
        telefone: {
          value: "",
          error: false,
        },
        atvidade: {
          value: "",
          error: false,
        },
        endereco: {
          value: "",
          error: false,
        },
        bairro: {
          value: "",
          error: false,
        },
        numero: {
          value: "",
          error: false,
        },

        contato_nome: {
          value: "",
          error: false,
        },
        contato_telefone: {
          value: "",
          error: false,
        },

        login: {
          value: "",
          error: false,
        },
        password: {
          value: "",
          error: false,
        },
      },
    });

    async function getInReceita(cnpj) {
      try {
        const cnpjTratado = cnpj.replace(/[^\d]/g, "");
        const { data } = await services.cliente.consultaReceita({
          cnpjTratado,
        });

        state.cliente.email.value = data.email;
        state.cliente.razao_social.value = data.nome;
        state.cliente.nome_fantasia.value = data.fantasia;
        state.cliente.telefone.value = data.telefone;
        state.cliente.endereco.value = data.logradouro;
        state.cliente.bairro.value = data.bairro;
        state.cliente.numero.value = data.numero;
      } catch (error) {
        console.log(error);
      }
      /*
         try {
           const { data } = await axios.get(
             "https://receitaws.com.br/v1/cnpj/" + cnpjTradado
           );
   
           console.log(data);
         } catch (error) {
           console.log(error);
         }*/
    }

    async function criar() {
      var cliente = {};
      cliente.cnpj = state.cliente.cnpj.value;
      cliente.email = state.cliente.email.value;
      cliente.razao_social = state.cliente.razao_social.value;
      cliente.nome_fantasia = state.cliente.nome_fantasia.value;
      cliente.telefone = state.cliente.telefone.value;
      cliente.atvidade = state.cliente.atvidade.value;
      cliente.endereco = state.cliente.endereco.value;
      cliente.bairro = state.cliente.bairro.value;
      cliente.numero = state.cliente.numero.value;
      cliente.contato_nome = state.cliente.contato_nome.value;
      cliente.contato_telefone = state.cliente.contato_telefone.value;
      cliente.login = state.cliente.login.value;
      cliente.password = state.cliente.password.value;

      await services.cliente
        .salvar({ cliente })
        .then(() => {
          showToastSuccess();
          setTimeout(() => {
            router.push("/login");
          }, 3000);
        })
        .catch((error) => {
          const erros = error.response.data.errors;
          console.log(erros);

          let errorMessages = "Erro ao cadastrar!\n";
          for (const messages of Object.values(erros)) {
            for (const message of messages) {
              errorMessages += `${message}\n`;
            }
          }

          showToast(errorMessages);
        });
    }

    function toggleButton() {
      const simOption = document.querySelector(
        'input[name="consent"][value="sim"]'
      );
      const submitButton = document.getElementById("submitButton");

      if (simOption.checked) {
        submitButton.disabled = false;
        submitButton.classList.remove("disabled");
        submitButton.classList.add("enabled");
      } else {
        submitButton.disabled = true;
        submitButton.classList.remove("enabled");
        submitButton.classList.add("disabled");
      }
    }

    function showToast(message) {
      const toast = document.getElementById("toast");
      toast.textContent = message;
      toast.classList.add("show");
      setTimeout(() => {
        toast.classList.remove("show");
      }, 3000);
    }

    function showToastSuccess() {
      const toast = document.getElementById("toast_sucess");
      toast.textContent = "Cliente cadastrado com sucesso";
      toast.classList.add("show");
      setTimeout(() => {
        toast.classList.remove("show");
      }, 3000);
    }

    return {
      state,
      criar,
      getInReceita,
      toggleButton,
      showToast,
      showToastSuccess,
    };
  },
};
</script>
<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap");

.toast_sucess {
  position: fixed;
  top: 20px;
  right: 20px;
  background-color: #059e00;
  color: white;
  padding: 10px 20px;
  border-radius: 5px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  opacity: 0;
  transform: translateY(-20px);
  transition: opacity 0.3s ease, transform 0.3s ease;
  z-index: 10000;
  font-weight: 700;
}

.toast_sucess.show {
  opacity: 1;
  transform: translateY(0);
}

.toast {
  position: fixed;
  top: 20px;
  right: 20px;
  background-color: #ff4d4d;
  color: white;
  padding: 10px 20px;
  border-radius: 5px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  opacity: 0;
  transform: translateY(-20px);
  transition: opacity 0.3s ease, transform 0.3s ease;
  z-index: 10000;
  font-weight: 700;
}

.toast.show {
  opacity: 1;
  transform: translateY(0);
}

section {
  background: #eff3f8;
  min-height: 100vh;
  max-height: auto;
}

.div_geral {
  display: flex;
}

.div_img {
  text-align: center;
  width: 100%;
}

.div_img p {
  color: #434343;
  font-weight: 300;
  font-size: 18px;
  font-family: "Poppins", sans-serif;
}

.div_img img {
  object-fit: clientein;
  width: 150px;
  margin: 20px 0px;
}

.btn_save {
  width: 200px;
  color: #fff;
  padding: 12px;
  border: none;
  border-radius: 5px;
  font-size: 12pt;
  font-weight: 700;
  font-family: "Poppins", sans-serif;
}

.btn_ativado {
  background-color: #560382 !important;
}

.btn_desativado {
  background-color: #fac49b !important;
}

.div_form {
  margin: 20px;
}

label {
  margin-top: 0.5rem;
  font-size: 14px;
  font-family: "Poppins", sans-serif;
  font-weight: 300;
}

.input {
  /*border: 1px solid #0000001a;
  background: #00000005;*/
  background-color: #fff;
  border: none;
  padding: 12px;
  width: 100%;
  outline: none;
  font-family: "Poppins", sans-serif;
}

.input:focus {
  border: 1px solid #560382;
}

.select {
  background-color: #fff;
  border: none;
  padding: 12px;
  width: 100%;
  outline: none;
  font-family: "Poppins", sans-serif;
}

.select:focus {
  border: 1px solid #560382;
}

p {
  color: #787878;
  margin-top: 1rem;
  font-size: 16px;
  font-weight: 600;
  font-family: "Poppins", sans-serif;
  margin-bottom: 0;
}

.voltar {
  color: #560382;
  font-family: "Poppins", sans-serif;
  font-weight: 400;
  font-size: 16px;
  display: inline-block;
  transition: transform 0.3s ease;
  position: absolute;
  left: 50px;
  top: 50px;
}

.voltar:hover {
  transform: translateX(-10px);
  /* Move o link 10 pixels para a esquerda */
}

@media (max-width: 576px) {
  .div_img p {
    font-size: 20px;
    line-height: 1.2;
  }

  .voltar {
    display: none;
  }
}
</style>